<template>
  <Dialog
    width="560px"
    height="unset"
    titleAlign="left"
    :title="null"
    :subTitle="null"
    :visible="visible"
    hideCloseBtn
    @close="closeDialog"
    customClass="vip-release-dialog"
  >
    <div class="result-wrapper">
      <div @click="closeDialog" class="close-icon">
        <img src="@/assets/img/release/modal_close.png" />
      </div>
      <div class="res-title">
        {{
          item?.release_info?.release_state == 3
            ? "Releasing"
            : "Release completed"
        }}
      </div>
      <div class="res-desc">
        {{
          item?.release_info?.release_state == 3
            ? ` We are busy releasing to 200+ platforms for you, with an estimated
        completion time of 20 business days.`
            : `You can search for the song title on various platforms to view it.`
        }}
       
      </div>
      <div class="res-song-card">
        <SongCard
          v-if="item"
          class="detail"
          type="release"
          :data="{
            ...item,
            song_url: item?.mp3_url,
            cover: release_info?.cover,
            user: userDataStore.userInfo.user,
            publish_at: release_info?.submitted_at,
          }"
          @togglePlay="togglePlay(info)"
          @changeFavorite="(state) => changeFavorite(info, state)"
        ></SongCard>
      </div>
      <div class="res-learn-more" @click="$router.push('/release')">
        learn more
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { ref } from "vue";
import SongCard from "@/page/home/components/songCardNew.vue";
import useFeedListStore from "@/store/create/feedListDataStore.js";
import useUserDataStore from "@/store/userDataStore";

const userDataStore = useUserDataStore();
const feedListStore = useFeedListStore();

const item = computed(() => feedListStore.release.item);
const release_info = computed(() => feedListStore.release.release_info);

const info = ref({
  mp3_url: "1",
});

const closeDialog = () => {
  feedListStore.closeReleaseResultDialog();
};

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const togglePlay = (data) => {
  //   globalPlayDataStore.updatePlayDataItem(data);
};

const changeFavorite = (data, state) => {
  //   if (state == 1) {
  //     globalProperties.logClickEvent("song_like", {
  //       content_id: data.song_id,
  //       source: isFromShare.value ? "song_share_page" : "song_detail_page",
  //     });
  //   }
  //   shopCartStore.updateShopLike(data.song_id, state);
  //   storeDetailDataStore.updateDetail({
  //     ...info.value,
  //     favorite_state: state,
  //     is_liked: state === 1 ? false : true,
  //   });
  //   globalPlayDataStore.updatePlayDataItem({
  //     ...info.value,
  //     favorite_state: state,
  //     is_liked: state === 1 ? false : true,
  //   });
};
</script>

<style lang="scss" scoped>
:deep(.dialog-box) {
  padding: 0;
}
.result-wrapper {
  padding: 16px 28px;
  border-radius: 20px;
  background: linear-gradient(14deg, #e3faff -2%, #f9dcff 108%),
    linear-gradient(131deg, #4fdeff 0%, #e675ff 100%);

  .close-icon {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .res-title {
    margin-top: 24px;
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    line-height: 44px;
  }
  .res-desc {
    margin-top: 16px;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    line-height: 24px;
  }
  .res-song-card {
    margin-top: 28px;
    background: #000000;
    border-radius: 20px;
  }
  .res-learn-more {
    text-align: end;
    font-size: 14px;
    font-weight: normal;
    line-height: 24px;
    text-align: right;
    letter-spacing: 0em;
    text-decoration: underline;
    color: #00000040;
    margin-top: 12px;
    cursor: pointer;
  }
  :deep(.detail) {
    .title-box {
      margin: 0 12px 0 32px;
      .title {
        font-size: 27.34px;
        font-weight: bold;
        line-height: normal;
        color: #ffffff;
      }
      .publish-icon {
        display: none;
      }
      .nickname {
        font-size: 14px;
        font-weight: normal;
        line-height: 16px;
        margin-top: 12px;
      }
      .tag {
        margin-top: 9px;
      }
    }
    .cover {
      .cover-img {
        width: 203px;
        height: 203px;
      }
    }
    .use-box {
      margin-top: 30px;
    }
    .audio-item-publish-btn {
      display: none;
    }
  }
}

@media screen and (max-width: 768px) {
  .result-wrapper {
    .res-desc {
      width: 263px;
      margin: 16px auto 0;
    }
    .res-song-card {
      width: 263px;
      margin: 28px auto 0;
    }
  }
}
</style>
